import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloUser,cleanAloUser } from '@/models/alo/AloUser'
import { AlsUser, cleanAlsUser } from '@/models/als/AlsUser'

export default {
  getAllUser(): AxiosPromise<AlrContainer<Array<AloUser>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/User`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloUser>>
      }]
    })
  },
  getUser(id:number):AxiosPromise<AlrContainer<AloUser>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/User/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloUser>
      }]
    })
  },
  saveUser(user:AloUser):AxiosPromise<AlrContainer<AloUser>> {
    cleanAloUser(user)
    if(user.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/User/${user.id}`, 
        method: 'PUT',
        data: user,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloUser>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/User`, 
        method: 'POST',
        data: user,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloUser>
        }]
      })    
    }
  },
  deleteUser(id:number):AxiosPromise<AlrContainer<AloUser>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/User/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloUser>
      }]
    })
  },
  getFilterUser(usrFilter : AlsUser): AxiosPromise<AlrContainer<Array<AloUser>>> {    
    cleanAlsUser(usrFilter)
    return apiHelpers.apiCall({ 
      url: `/webapi/User/filter`, 
      data:usrFilter,
      method: 'POST',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloUser>>
      }]
    })
  },
}